// English (India) translations for Dashboard
console.log('English translation file loaded');
export const en_IN = {
  // Dashboard Header
  dashboard: "Dashboard",
  welcomeBack: "Welcome back! Here's your business overview.",
  
  
  // Loading & Error States
  loadingDashboard: "Loading dashboard data...",
  errorLoadingDashboard: "Error loading dashboard data",
  retry: "Retry",
  
  // Quick Actions Section
  quickActions: "Quick Actions",
  quickActionsDesc: "Access your main business functions",
  sales: "SALES",
  purchase: "PURCHASE", 
  payment: "PAYMENT",
  parties: "PARTIES",
  items: "ITEMS",
  expenses: "EXPENSES",
  reports: "REPORTS",
  taxes: "TAXES",
  settings: "SETTINGS",
  
  // Todo List Section
  todoList: "To-Do List",
  todoListDesc: "Manage your daily tasks and priorities",
  addNewTask: "+ Add New Task",
  add: "Add",
  allCategories: "All Categories",
  personal: "Personal",
  meeting: "Meeting",
  urgent: "Urgent",
  followUp: "Follow Up",
  business: "Business",
  reminder: "Reminder",
  project: "Project",
  other: "Other",
  welcomeTodo: "Welcome to Your Todo List!",
  startOrganizing: "Start organizing your tasks and stay productive",
  createFirstTask: "Create Your First Task",
  
  // Business Overview Section
  businessOverview: "Business Overview",
  businessOverviewDesc: "Complete business metrics and outstanding details",
  show: "Show",
  hide: "Hide",
  summaryMetrics: "Summary Metrics",
  monthlySales: "Monthly Sales:",
  monthlyPurchase: "Monthly Purchase:",
  outstandingBalance: "Outstanding Balance:",
  outstandingPayable: "Outstanding Payable:",
  
  // Outstanding Receivable
  outstandingReceivable: "Outstanding Receivable",
  moneyOwedToBusiness: "Money owed to your business",
  viewMore: "View More",
  lastPayment: "Last payment:",
  noOutstandingReceivables: "No outstanding receivables",
  
  // Outstanding Payable
  outstandingPayable: "Outstanding Payable", 
  moneyOwedToSuppliers: "Money you owe to suppliers",
  noOutstandingPayables: "No outstanding payables",
  
  // Company Information
  companyInformation: "Company Information",
  gstin: "GSTIN:",
  contact: "Contact:",
  email: "Email:",
  address: "Address:",
  customers: "Customers:",
  suppliers: "Suppliers:",
  items: "Items:",
  
  // Software Footer
  simplifyingAccounting: "Simplifying Accounting, Together",
  allRightsReserved: "All rights reserved.",
  
  // Sales Page
  invoice: "INVOICE",
  quotation: "QUOTATION",
  receipt: "RECEIPT",
  selectItem: "Select Item",
  additionalNotes: "Additional notes for this invoice",
  ewayBillNumber: "Enter e-way bill number",
  filterByInvoiceNumber: "Filter by invoice number",
  filterByPartyName: "Filter by party name",
  filterByAmount: "Filter by amount",
  date: "Date",
  party: "Party",
  amount: "Amount",
  paid: "Paid",
  outstanding: "Outstanding",
  confirmDelete: "Confirm Delete",
  delete: "Delete",
  cancel: "Cancel",
  addNewItem: "Add New Item",
  addItem: "Add Item",
  enterItemName: "Enter item name",
  service: "Service",
  goods: "Goods",
  enterCustomUnit: "Enter custom unit",
  enterHsnCode: "Enter HSN code",
  enterItemDescription: "Enter item description",
  addPayment: "Add Payment",
  savePayment: "Save Payment",
  enterPaymentAmount: "Enter payment amount",
  cash: "Cash",
  cheque: "Cheque",
  bankTransfer: "Bank Transfer",
  card: "Card",
  additionalNotes: "Additional notes",
  paymentReceipts: "Payment Receipts",
  paymentReceiptPreview: "Payment Receipt Preview",
  
  // Purchases Page
  purchaseBill: "PURCHASE BILL",
  purchaseOrder: "PURCHASE ORDER",
  selectParty: "Select Party",
  partySeller: "Party (Seller)",
  totalAmount: "Total Amount",
  noItemsUsedYet: "No items used yet",
  additionalNotesPurchase: "Additional notes for this purchase bill",
  
  // Parties Page
  editParty: "Edit Party",
  addNewParty: "Add New Party",
  openingBalanceGuide: "Opening Balance Guide",
  positiveValue: "+ve Value:",
  customerOwesYou: "Customer owes you money (Udhari/Receivable)",
  negativeValue: "-ve Value:",
  youOweSupplier: "You owe supplier money (Advance/Payable)",
  zeroValue: "0:",
  noOpeningBalance: "No opening balance",
  buyer: "Buyer (Customer)",
  seller: "Seller (Supplier)",
  both: "Both",
  regular: "Regular",
  composition: "Composition",
  unregistered: "Unregistered",
  fullAddress: "Full address",
  allExistingParties: "All existing parties have been automatically set to 'Regular' GST type",
  firmName: "Firm Name",
  personName: "Person Name",
  type: "Type",
  openingBalance: "Opening Balance",
  contact: "Contact",
  email: "Email",
  whatsapp: "WhatsApp",
  address: "Address",
  clearSelection: "Clear selection",
  viewFullReport: "View Full Report",
  detailedTransactionHistory: "Click 'View Full Report' to see detailed transaction history and ledger entries",
  
  // Items Page
  editItem: "Edit Item",
  addNewItem: "Add New Item",
  typeOrSelectUnit: "Type or select unit",
  enterCustomUnit: "Enter custom unit",
  goods: "Goods",
  services: "Services",
  restaurant: "Restaurant",
  other: "Other",
  baseMaterial: "Base Material",
  consumable: "Consumable",
  packingMaterial: "Packing Material",
  itemDescription: "Item description",
  purchasePricePerUnit: "Purchase Price (per unit)",
  salePricePerUnit: "Sale Price (per unit)",
  itemName: "Item Name",
  measurement: "Measurement",
  type: "Type",
  stock: "Stock",
  
  // Payments Page
  payments: "Payments",
  paymentReceipts: "Payment Receipts",
  paymentMode: "Payment Mode",
  invoice: "Invoice",
  challan: "Challan",
  purchase: "Purchase",
  receipts: "Receipts",
  viewPaymentReceipts: "View Payment Receipts",
  enterAmount: "Enter amount",
  additionalNotes: "Additional notes",
  backToReceiptsList: "Back to receipts list",
  printUsingBrowser: "Print using browser print dialog",
  downloadAsPDF: "Download as PDF file",
  
  // Expenses Page
  fixed: "Fixed",
  variable: "Variable",
  labourAdvances: "Labour/Advances",
  salaries: "Salary",
  rent: "Rent",
  electricity: "Electricity",
  internet: "Internet",
  water: "Water",
  other: "Other",
  officeExpense: "Office Expense",
  stationery: "Stationery",
  travel: "Travel",
  miscellaneous: "Miscellaneous",
  name: "Name",
  employee: "Employee",
  labour: "Labour",
  freelancer: "Freelancer",
  designation: "Designation",
  contact: "Contact",
  bankName: "Bank Name",
  bankAccountNumber: "Bank Account Number",
  address: "Address",
  viewDetails: "View Details",
  edit: "Edit",
  export: "Export",
  delete: "Delete",
  post: "Post",
  cash: "Cash",
  bankTransfer: "Bank Transfer",
  cheque: "Cheque",
  card: "Card",
  other: "Other",
  advance: "Advance",
  
  // Reports Page
  reportsDashboard: "Reports Dashboard",
  selectReportType: "Select Report Type",
  partyOptional: "Party (Optional)",
  allParties: "All Parties",
  loadingParties: "Loading parties…",
  
  // Settings Page
  settings: "Settings",
  security: "Security",
  mpin: "MPIN",
  login: "Login",
  back: "Back",
  verifyCode: "Verify Code",
  enterSixDigitCode: "Enter the 6-digit code sent to your {verificationMethod}",
  securityAndMpin: "Security & MPIN",
  setFourDigitMpin: "Set a 4-digit MPIN for additional security. This will be required for sensitive operations.",
  mpinAlreadySet: "MPIN is already set",
  enterFourDigitMpin: "Enter 4-digit MPIN",
  confirmMpin: "Confirm MPIN",
  setMpin: "Set MPIN",
  verifyCurrentMpin: "Verify Current MPIN",
  enterCurrentMpinToChange: "Please enter your current MPIN to change it.",
  forgotMpin: "Forgot MPIN?",
  chooseVerificationMethod: "Choose a verification method to reset your MPIN.",
  
  // Navigation
  dashboard: "Dashboard",
  sales: "Sales",
  purchases: "Purchases",
  customers: "Customers",
  suppliers: "Suppliers",
  invoices: "Invoices",
  payments: "Payments",
  reports: "Reports",
  settings: "Settings",
  items: "Items",
  parties: "Parties",
  expenses: "Expenses",
  manufacturing: "Manufacturing",
  billTemplates: "Bill Templates",
  allReports: "All Reports",
  taxes: "Taxes",
  companyDetails: "Company Details",
  employees: "Employees",
  converter: "Converter",
  reportToOwner: "Report to Owner",
  reportedIssues: "Reported Issues",
  business: "Business",
  company: "Company",
  multiCompany: "Multi-Company",
  multiCompanyPlatform: "Multi-Company Platform"
};

